import React from 'react';

const InformationFill = (props: object) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8 0.333008C12.2342 0.333008 15.667 3.76581 15.667 8C15.667 12.2342 12.2342 15.667 8 15.667C3.76581 15.667 0.333008 12.2342 0.333008 8C0.333008 3.76581 3.76581 0.333008 8 0.333008ZM5.91699 8.83301H6.91699V12.583H9.08301V8C9.08301 7.26363 8.48639 6.66699 7.75 6.66699H5.91699V8.83301ZM8 3.66699C7.26363 3.66699 6.66699 4.26363 6.66699 5C6.66699 5.73637 7.26363 6.33301 8 6.33301C8.73639 6.33301 9.33301 5.73637 9.33301 5C9.33301 4.26363 8.73639 3.66699 8 3.66699Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.666667"
      />
    </svg>
  );
};

export default InformationFill;
